import { Box, Button, TextField, Typography, useTheme, Alert, CircularProgress } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { tokens } from "../../theme";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { register } from "../../services/auth";
 
const RegisterPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
 
  const handleFormSubmit = async (values) => {
    setError('');
    setSuccess(false);
   
    // Validate form
    if (values.password !== values.confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }
   
    setLoading(true);

    try {
      await register(
        values.username,
        values.email,
        values.password,
        values.first_name,
        values.last_name,
        values.phone,
        values.plan
      );
      setSuccess(true);
     
      // Redirect to login after 2 seconds
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      setError(err.message || 'Échec de l\'inscription. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f8f9fa" // fond général très clair
    >
      <Box
        bgcolor="#fff" // bloc central blanc
        p="2.5rem"
        borderRadius="16px"
        width="100%"
        maxWidth="400px"
        boxShadow="0 6px 32px 0 rgba(25, 118, 210, 0.07), 0 1.5px 8px 0 rgba(0,0,0,0.03)"
      >
        <Typography variant="h3" color="#1976d2" fontWeight={700} mb="2rem" textAlign="center" fontFamily="Montserrat, Arial, sans-serif">
          Inscription
        </Typography>
 
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
       
        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Inscription réussie ! Redirection vers la page de connexion...
          </Alert>
        )}
 
        <Formik
          initialValues={{
            username: "",
            email: "",
            password: "",
            confirmPassword: "",
            first_name: "",
            last_name: "",
            phone: "",
            plan: "Essentiel",
          }}
          validationSchema={yup.object().shape({
            username: yup.string().required("Nom d'utilisateur requis").min(3, "Le nom d'utilisateur doit contenir au moins 3 caractères"),
            email: yup.string().email("Email invalide").required("Email requis"),
            password: yup
              .string()
              .required("Mot de passe requis")
              .min(6, "Le mot de passe doit contenir au moins 6 caractères"),
            confirmPassword: yup
              .string()
              .oneOf([yup.ref("password"), null], "Les mots de passe doivent correspondre")
              .required("Confirmation du mot de passe requise"),
            first_name: yup.string().required("Prénom requis"),
            last_name: yup.string().required("Nom requis"),
            phone: yup.string().required("Numéro de téléphone requis"),
            plan: yup.string().required("Plan requis"),
          })}
          onSubmit={handleFormSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box display="flex" flexDirection="column" gap="1.5rem">
                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  label="Prénom"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.first_name}
                  name="first_name"
                  error={!!touched.first_name && !!errors.first_name}
                  helperText={touched.first_name && errors.first_name}
                  InputProps={{
                    style: { background: '#fff', borderRadius: 8, fontFamily: 'Montserrat, Arial, sans-serif' }
                  }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  label="Nom"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.last_name}
                  name="last_name"
                  error={!!touched.last_name && !!errors.last_name}
                  helperText={touched.last_name && errors.last_name}
                  InputProps={{
                    style: { background: '#fff', borderRadius: 8, fontFamily: 'Montserrat, Arial, sans-serif' }
                  }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type="tel"
                  label="Numéro de téléphone"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.phone}
                  name="phone"
                  error={!!touched.phone && !!errors.phone}
                  helperText={touched.phone && errors.phone}
                  InputProps={{
                    style: { background: '#fff', borderRadius: 8, fontFamily: 'Montserrat, Arial, sans-serif' }
                  }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  label="Nom d'utilisateur"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.username}
                  name="username"
                  error={!!touched.username && !!errors.username}
                  helperText={touched.username && errors.username}
                  InputProps={{
                    style: { background: '#fff', borderRadius: 8, fontFamily: 'Montserrat, Arial, sans-serif' }
                  }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  label="Plan"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plan}
                  name="plan"
                  error={!!touched.plan && !!errors.plan}
                  helperText={touched.plan && errors.plan}
                  InputProps={{
                    style: { background: '#fff', borderRadius: 8, fontFamily: 'Montserrat, Arial, sans-serif' }
                  }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  label="Email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.email}
                  name="email"
                  error={!!touched.email && !!errors.email}
                  helperText={touched.email && errors.email}
                  InputProps={{
                    style: { background: '#fff', borderRadius: 8, fontFamily: 'Montserrat, Arial, sans-serif' }
                  }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type="password"
                  label="Mot de passe"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.password}
                  name="password"
                  error={!!touched.password && !!errors.password}
                  helperText={touched.password && errors.password}
                  InputProps={{
                    style: { background: '#fff', borderRadius: 8, fontFamily: 'Montserrat, Arial, sans-serif' }
                  }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type="password"
                  label="Confirmer le mot de passe"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.confirmPassword}
                  name="confirmPassword"
                  error={!!touched.confirmPassword && !!errors.confirmPassword}
                  helperText={touched.confirmPassword && errors.confirmPassword}
                  InputProps={{
                    style: { background: '#fff', borderRadius: 8, fontFamily: 'Montserrat, Arial, sans-serif' }
                  }}
                />
                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading || success}
                  sx={{
                    bgcolor: '#1976d2',
                    color: '#fff',
                    fontWeight: 700,
                    fontFamily: 'Montserrat, Arial, sans-serif',
                    borderRadius: 2,
                    fontSize: 16,
                    py: 1.2,
                    mt: 1,
                    '&:hover': { bgcolor: '#145ea8' }
                  }}
                >
                  {loading ? <CircularProgress size={24} sx={{ color: 'inherit' }} /> : "S'inscrire"}
                </Button>
                <Typography
                  variant="body2"
                  sx={{
                    color: '#1976d2',
                    textAlign: 'center'
                  }}
                >
                  Déjà un compte ?{" "}
                  <Button
                    href="/login"
                    sx={{
                      color: '#1976d2',
                      textTransform: "none",
                      '&:hover': { color: '#145ea8' }
                    }}
                  >
                    Se connecter
                  </Button>
                </Typography>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};
 
export default RegisterPage;